import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

// Remove loading placeholder do HTML
const loadingPlaceholder = document.getElementById('loading-placeholder');
if (loadingPlaceholder) {
  loadingPlaceholder.remove();
}

// Inicializa Sentry ANTES de renderizar a aplicação
import sentryService from "./services/sentryService";
sentryService.initialize();

const ErrorBoundary = sentryService.getErrorBoundary();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={({ error, componentStack, resetError }) => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Oops! Algo deu errado 😔</h1>
          <p>Nossa equipe foi notificada e estamos trabalhando para corrigir o problema.</p>
          <details style={{ whiteSpace: 'pre-wrap', marginTop: '20px' }}>
            <summary>Detalhes técnicos</summary>
            <div>{error ? String(error) : 'Erro desconhecido'}</div>
            <div>{componentStack ? String(componentStack) : ''}</div>
          </details>
          <button
            onClick={resetError}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              cursor: 'pointer',
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
            }}
          >
            Tentar novamente
          </button>
        </div>
      )}
      showDialog
    >
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
